
























































































import { Component, Vue, Prop, Provide, Mixins } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { PaperItem, NoBinds } from '@/components'
import {
  paperDetail,
  paperDoc,
  paperDocS2,
  getPaperListDetail,
  assembleDetail,
  assembleDownload,
  assessmentPaperDetail,
  assessmentDownload
} from './models/api'
import { loadFromLocal } from '@/utils/local'
import DownloadModal from './components/DownloadModal.vue'
import Office from './components/Office.vue'
import CmsPreview from './components/CmsPreview.vue'
import PaperPreview from './components/PaperPreview.vue'
import QuestionBus from '../question/components/QuestionBus.vue'
import QuestionCenter from '../assessment/components/QuestionCenter.vue'
import pdf from './pdf.vue'
import { windowOpen } from '@/utils/urlUtils'
import Download from './mixins/download'
const position = '试卷详情页'

@Component({
  components: {
    MainTemplate,
    PaperItem,
    pdf,
    DownloadModal,
    NoBinds,
    Office,
    PaperPreview,
    QuestionBus,
    CmsPreview,
    QuestionCenter
  }
})
export default class PaperDetail extends Mixins(Download) {
  public paper = {
    preview_doc_srcs: ''
  }
  public visible = false
  public size = 'large'
  public testModal = false
  public loading = false
  public youDian = {}
  // public loadingModal = false
  public currentUrl = ''
  public currentPaper: any = {}
  public isBand = true
  public questions = []
  public loadingPaper = false
  public useRannder = false

  // computed
  public get currentSite() {
    return ~~this.$route.query.site
  }
  public get userName() {
    return this.$store.state.user_info ? this.$store.state.user_info.nickname : undefined
  }
  public get id() {
    return this.$route.query._id
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  public get isAssemble() {
    return this.$route.query.assemble === '1'
  }
  public get isCeping() {
    return this.$route.query.ceping === '1'
  }
  public get site() {
    return this.$route.query.site
  }
  public get site_name() {
    return this.$route.query.site_name
  }
  public get grade() {
    return this.$route.query.grade
  }
  public get grade_name() {
    return this.$route.query.grade_name
  }
  public get paper_type() {
    return this.$route.query.paper_type
  }
  public get paper_type_name() {
    return this.$route.query.paper_type_name
  }
  public get region_code() {
    return this.$route.query.region_code
  }
  public get region_name() {
    return this.$route.query.region_name
  }
  public get year() {
    return this.$route.query.year
  }
  public get from() {
    return this.$route.query.home || ''
  }
  public get isDownloaded() {
    return this.$route.query.is_downloaded == 'true'
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get formMyDownload() {
    if (String(this.from) === 'personal/download') {
      return '我的下载'
    } else if (String(this.from) === 'personal/favorite') {
      return '我的收藏'
    } else {
      return '试卷'
    }
  }

  // methods
  /**
   * mounted
   */
  public mounted() {
    if (this.userName) {
      this.getData()
      if (this.from === '组卷') {
        // this.getQuestions()
      }
    } else {
      window.location.href = '/index'
    }
    document.oncontextmenu = () => false
  }
  public judgeRender(val) {
    if (val && val.length) {
      return val.every((item) => {
        if (!item) return
        return (
          item.indexOf('.zip') !== -1 ||
          (item.substring(item.length - 6).indexOf('.') === -1 && item.indexOf(';base64') === -1) ||
          item.indexOf('.mp3') !== -1 ||
          item.indexOf('.rar') !== -1
        )
      })
    } else {
      return false
    }
  }
  /**
   * judgePics
   */
  public judgePics(item) {
    let whiteList = ['.jpg', '.png', '.gif', '.jpeg', '.svg', ';base64']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  /**
   * judgeOffice
   */
  public judgeOffice(item) {
    let whiteList = ['.doc', '.docx', '.xls', '.xlsx']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  public downloadInfoChange(val) {
    if (this.visible) {
      this.getPaperDoc(this.currentPaper.id, val)
    }
  }
  /**
   * cancelModal
   */
  public cancelModal() {
    this.visible = false
  }
  /**
   * getData
   */
  public async getData() {
    this.loading = true

    let data
    if (this.isAssemble) {
      data = await assembleDetail({
        subject_id: this.subjectId,
        assemble_record_id: this.id
      })

      this.loading = false
      if (data.success) {
        this.isBand = true
        let paper = Object.assign({}, data.data, {
          is_downloaded: this.isDownloaded
        })
        paper.id = this.id
        paper.is_excellent = true
        this.paper = paper
      } else {
        this.paper = { preview_doc_srcs: '' }
        if (data.error === '请登录') {
          this.$store.commit('SET_LOGINMODAL', true)
        }
      }
    } else if (this.isCeping) {
      const data: any = await assessmentPaperDetail({
        subject_id: Number(this.subjectId),
        assessment_paper_record_id: Number(this.id)
      })

      this.loading = false
      if (data.success) {
        this.isBand = true
        let paper = Object.assign({}, data.data, {
          is_downloaded: this.isDownloaded
        })
        paper.id = this.id
        this.paper = paper
      } else {
        this.paper = { preview_doc_srcs: '' }
        if (data.error === '请登录') {
          this.$store.commit('SET_LOGINMODAL', true)
        }
        this.$warning({
          title: data.error,
          maskClosable: false,
          okText: '知道了',
          onOk: () => {
            this.$router.replace('/index')
          }
        })
      }
    } else {
      const data: any = await paperDetail({
        subject_id: this.subjectId,
        paper_id: this.id
      })

      this.loading = false
      if (data.success) {
        this.isBand = true
        let paper = Object.assign({}, data.data, {
          is_downloaded: this.isDownloaded
        })
        paper.id = this.id
        this.paper = paper
      } else {
        this.paper = { preview_doc_srcs: '' }
        if (data.error === '请登录') {
          this.$store.commit('SET_LOGINMODAL', true)
        } else {
          this.$warning({
            title: data.error,
            maskClosable: false,
            okText: '知道了',
            onOk: () => {
              this.$router.replace('/index')
            }
          })
        }
      }
    }
  }
  public async getPaperDoc(val, obj?: any) {
    let count = 0
    let req: any = {
      subject_id: this.subjectId,
      paper_id: val
    }
    let res: any = null
    if (obj) {
      req = Object.assign({}, req, obj)
    }
    // 判断使用哪个下载
    if (this.isAssemble) {
      this.loadingModal = true
      req.assemble_record_id = req.paper_id
      try {
        const data: any = await assembleDownload(req)
        this.loadingModal = false
        if (data.error === '请登录') {
          this.cancelModal()
          this.$store.commit('SET_LOGINMODAL', true)
          return
        }
        if (!data.data) {
          if (data.error) {
            this.$message.warning(data.error)
          }
          return
        }
        this.loadingModal = false

        if (data.success) {
          this.getSource(data.data.task_id, count, req.subject_id, val, String(this.from))
        }
      } catch (e) {
        this.loadingModal = false
      }
    } else if (this.isCeping) {
      this.loadingModal = true
      req.assessment_paper_record_id = req.paper_id
      try {
        const data: any = await assessmentDownload(req)
        this.loadingModal = false
        if (data.error === '请登录') {
          this.cancelModal()
          this.$store.commit('SET_LOGINMODAL', true)
          return
        }
        if (!data.data) {
          if (data.error) {
            this.$message.warning(data.error)
          }
          return
        }
        this.loadingModal = false

        if (data.success) {
          this.getSource(data.data.task_id, count, req.subject_id, val, String(this.from))
        }
      } catch (e) {
        this.loadingModal = false
      }
    } else {
      this.loadingModal = true
      try {
        const data: any = await paperDoc(req)
        this.loadingModal = false
        if (data.error === '请登录') {
          this.cancelModal()
          this.$store.commit('SET_LOGINMODAL', true)
          return
        }
        if (!data.data) {
          if (data.error) {
            this.$message.warning(data.error)
          }
          return
        }
        // this.loadingModal = false
        if (data.success) {
          this.getSource(data.data.task_id, count, req.subject_id, val, String(this.from))
        }
      } catch (e) {
        this.loadingModal = false
      }
    }
  }
  /**
   * clickDownload
   */
  public clickDownload(val: any) {
    this.currentPaper = {
      id: this.id,
      name: val.name
    }
    if (!this.userName) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    let param = val
    window['sensors'].track('TIKU_Download', {
      proSource: this.formMyDownload,
      content: '试卷',
      paper_subject: this.$store.state.subject.label,
      is_not: val.is_excellent ? '是' : '否'
    })

    this.getPaperDoc(this.id, param)
  }
}
